import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import BlogAuthor from './BlogAuthor';
import BlogCategories from '../BlogCategories';
import ForumNav from '../ForumNav';
export default class BlogItemSidebar extends Component {
  view(vnode) {
    return m("div", {
      className: 'FoFBlog-Article-Sidebar'
    }, m("ul", null, listItems(this.items().toArray())));
  }
  items() {
    const itemlist = new ItemList();
    itemlist.add('author', m(BlogAuthor, this.attrs), 0);
    itemlist.add('categories', m(BlogCategories, this.attrs), 0);
    itemlist.add('nav', m(ForumNav, this.attrs), 0);
    return itemlist;
  }
}
flarum.reg.add('fof-blog', 'forum/components/BlogItemSidebar/BlogItemSidebar', BlogItemSidebar);